import type { JSX } from 'react';

import { Translate } from '@change-corgi/core/react/i18n';
import { Icon } from '@change-corgi/design-system-legacy/components/icon';
import { getSocialIcon } from '@change-corgi/design-system-legacy/components/social';
import { Flex } from '@change-corgi/design-system-legacy/layout';
import { Heading } from '@change-corgi/design-system-legacy/typography';

import type { FacebookShareRecommendations } from '../../hooks/useFetchShareRecommendations';

import { FacebookCard } from './components/FacebookCard';

type Props = {
	shareRecommendations: FacebookShareRecommendations;
};

export function FacebookGroupsVariant({ shareRecommendations }: Props): JSX.Element | null {
	if (shareRecommendations.length === 0) {
		return null;
	}

	return (
		<Flex sx={{ flexDirection: 'column', gap: 16, flexBasis: ['auto', '430px'] }}>
			<Heading
				as="h3"
				size={['h4']}
				sx={{ display: 'flex', gap: 10, flexGrow: 0, alignItems: 'center' }}
				id="facebook-recommendations-title"
				data-qa="recommendations-title"
				tabIndex={0}
				aria-label="Recommended Facebook Groups"
			>
				<Icon icon={getSocialIcon('fb')} size={32} color="#1877F2" />
				<Translate value="corgi.petition.starter_dashboard.recommendations.facebook.title" />
			</Heading>
			<Flex sx={{ flexDirection: 'column', gap: 16 }} data-testid="facebook-groups-list">
				{shareRecommendations.map((group) => (
					<FacebookCard recommendation={group} key={group.url} />
				))}
			</Flex>
		</Flex>
	);
}
